angular
  .module('vppApp')
  .directive('chat', function() {
      return {
          restrict: 'C',
          link: function(scope, elem, attrs) {
              elem.bind('click', function() {   
                  // get the data-ng-chat value from the <a>
                  // create the window and fire it
                  var win = open( attrs.ngChat, 'Live Chat', 'width=320,height=520,top=200,left=200' );
                  win.focus();
              });
          }
      };
  });
